module.exports = __webpack_public_path__ + "static/media/blacktile.01444d5d.gif";